import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Headphones"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 12V11.25C18.75 7.52208 15.7279 4.5 12 4.5C8.27208 4.5 5.25 7.52208 5.25 11.25V12C3.17893 12 1.5 13.6789 1.5 15.75C1.5 17.8211 3.17893 19.5 5.25 19.5H6.75V11.25C6.75 8.35051 9.1005 6 12 6C14.8995 6 17.25 8.35051 17.25 11.25V19.5H18.75C20.8211 19.5 22.5 17.8211 22.5 15.75C22.5 13.6789 20.8211 12 18.75 12ZM3 15.75C3 14.5074 4.00736 13.5 5.25 13.5V18C4.00736 18 3 16.9926 3 15.75ZM18.75 18V13.5C19.9926 13.5 21 14.5074 21 15.75C21 16.9926 19.9926 18 18.75 18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Headphones.vue"]]);
